export const fontSize = {
  ProductName: "25px",
  heading: "22px",
  question: "18px",
  reservationDetails: "17px",
  modalInput: "16px",
  selected: "15px",
  label: "14px",
  pageNav: "13px",
  paragraph: "13px",
  tooltip: "10px",
};
